import EmailService from '@/services/users/EmailService';

/**
 * Check if email is available
 *
 * @param {String} email
 *
 * @returns {Boolean}
 */
export const isEmailUnique = (email) => {
    return (new EmailService()).isEmailAvailable(email);
};
